export interface IncludedItem {
  name: string;
  count: number;
}

export interface InputField {
  name: string;
  dataType: string;
  required: boolean;
  description?: string;
  icon?: string;
  options?: string[]; // For select fields
}

export interface Service {
  serviceId: string;
  serviceName: string;
  serviceIcon: string;
  serviceDescription: string;
  price: number;
  includedItems: IncludedItem[];
  isActive: boolean;
  requiredInfoFields: InputField[];
}

export interface Testimonial {
  author: string;
  text: string;
}

// Available time slots for booking
export const TIME_SLOTS = [
  '10:00 AM',
  '12:00 PM',
  '2:00 PM',
  '4:00 PM'
] as const;

export type TimeSlot = typeof TIME_SLOTS[number];

export interface OrderCreateRequest {
  serviceId: string;
  requiredInfo: Record<string, any>;
  userInfo: {
    name: string;
    phone: string;
    address: string;
  };
  timeSlot: string;
  startDate: string;
  priceShown: number;
}

export interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

export interface AppConfig {
  appName: string;
  version: string;
  features: {
    showPrices: boolean;
  };
}
